import { type MCPServerInfo } from '../../types';

const DovetailServer: MCPServerInfo = {
  serverId: 'DOVETAIL',
  name: 'Dovetail',
  slug: 'dovetail',
  description: 'Dovetail MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/dovetail/dovetail-mcp',
    commitSha: '1269378',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['dovetailApiToken'],
    properties: {
      dovetailApiToken: {
        type: 'string',
        description: 'Dovetail API Token',
        sensitive: true
      }
    }
  }
};

export default DovetailServer;
